document.addEventListener('DOMContentLoaded', () => {
    initCkDatacheck();
  });
  
  document.addEventListener('teeinblue-event-component-injected', () => {
    initCkDatacheck();
  });
  
  /* -----------------------------------------------------
     Check if datacheck exists in cart
  ----------------------------------------------------- */
  async function checkDatacheckInCart() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      return cart.items.some(i => i.properties && i.properties._datacheck);
    } catch (e) {
      return false;
    }
  }
  
  /* -----------------------------------------------------
     Global visibility updater
  ----------------------------------------------------- */
  // Booked once per order: a short note where the choice was ("gilt für alle Produkte in deiner Bestellung")
  function showInOrderNote(on) {
    const old = document.querySelector('.ck-datacheck-note');
    const original = document.querySelector('[data-datacheck-wrapper]');
    const text = original && original.getAttribute('data-in-order-note');
    const actions = document.querySelector('#teeFormActions');
    if (!on || !text || !actions) { if (old) old.remove(); return; }
    if (old) return;
    const note = document.createElement('p');
    note.className = 'ck-datacheck-note';
    note.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    const span = document.createElement('span');
    span.textContent = text;
    note.appendChild(span);
    actions.insertAdjacentElement('beforebegin', note);
  }

  async function refreshDatacheckVisibility() {
    const original = document.querySelector('[data-datacheck-wrapper]');
    const injected = document.querySelector('.ck-datacheck--injected');
    const hasDatacheck = await checkDatacheckInCart();
  
    if (hasDatacheck) {
      localStorage.setItem('ck_datacheck_in_cart', 'true');
  
      if (original) original.classList.add('ck-datacheck-hidden');
      if (injected) injected.classList.add('ck-datacheck-hidden');
      showInOrderNote(true);
    } else {
      localStorage.removeItem('ck_datacheck_in_cart');
      showInOrderNote(false);
  
      // show original block again
      if (original) original.classList.remove('ck-datacheck-hidden');
  
      // reinject if needed
      const tibAtc = document.querySelector('.tee-btn--atc');
      const exists = document.querySelector('.ck-datacheck--injected');
  
      if (tibAtc && !exists) {
        initCkDatacheck(); // re-add clone
      }
    }
  }
  
  /* -----------------------------------------------------
     Core injection logic
  ----------------------------------------------------- */
  function initCkDatacheck() {
    const original = document.querySelector('[data-datacheck-wrapper]');
    if (!original) return;
  
    // Hide everywhere if already purchased
    if (localStorage.getItem('ck_datacheck_in_cart') === 'true') {
      original.classList.add('ck-datacheck-hidden');
      showInOrderNote(true);
      return;
    }
  
    // Theme editor view
    if (Shopify.designMode) {
      original.classList.remove('ck-datacheck-hidden');
      return;
    }
  
    const tibAtcButton = document.querySelector('.tee-btn--atc');
    if (!tibAtcButton) return;
  
    // Prevent duplicates
    if (document.querySelector('.ck-datacheck--injected')) return;
  
    // Clone block
    const clone = original.cloneNode(true);
    clone.classList.add('ck-datacheck--injected');
    clone.classList.remove('ck-datacheck-hidden');
  
    // Inject ABOVE buttons
    const atcWrapper = document.querySelector('#teeFormActions');
  
    if (atcWrapper) {
      atcWrapper.insertAdjacentElement('beforebegin', clone);
    } else {
      const fallback = tibAtcButton.closest('#teeFormActions');
      if (fallback) fallback.prepend(clone);
    }
  
    // Hide the original
    original.classList.add('ck-datacheck-hidden');
  
    // Bind logic
    bindDatacheckEvents(clone);
    bindAddToCartHandler(clone);
  }
  
  /* -----------------------------------------------------
     Radio click handling
  ----------------------------------------------------- */
  function bindDatacheckEvents(wrapper) {
    const noneInput = wrapper.querySelector('[data-datacheck-none]');
    const paidInput = wrapper.querySelector('[data-datacheck-product]');
    if (!noneInput || !paidInput) return;
  
    let hidden = wrapper.querySelector('[data-datacheck-hidden-input]');
  
    function updateHiddenInput(variantId) {
      if (variantId === null) {
        if (hidden) {
          hidden.remove();
          hidden = null;
        }
        return;
      }
  
      if (!hidden || !wrapper.contains(hidden)) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'ck_datacheck_variant';
        hidden.dataset.datacheckHiddenInput = 'true';
        wrapper.appendChild(hidden);
      }
  
      hidden.value = variantId;
    }
  
    noneInput.addEventListener('change', () => updateHiddenInput(null));
    paidInput.addEventListener('change', () => updateHiddenInput(paidInput.value));
  }
  
/* -----------------------------------------------------
   Add-to-cart integration
----------------------------------------------------- */
function bindAddToCartHandler(wrapper) {
    const tibAtcBtn = document.querySelector('.tee-btn--atc');
    if (!tibAtcBtn) return;
  
    if (tibAtcBtn.dataset.ckDatacheckBound === 'true') return;
    tibAtcBtn.dataset.ckDatacheckBound = 'true';
  
    tibAtcBtn.addEventListener('click', async () => {
      const requiredMessages = document.querySelectorAll('.tee-required-message');
      const hasErrors = Array.from(requiredMessages).some(
        (el) => el.offsetParent !== null
      );
  
      if (hasErrors) {
        console.warn('[Datacheck] Required fields missing → skip datacheck add/remove');
        return;
      }
  
      const hidden = wrapper.querySelector('[data-datacheck-hidden-input]');
      const selectedVariant = hidden?.value || null;
  
      if (!selectedVariant) {
        await removeDatacheckProduct();
        setTimeout(refreshDatacheckVisibility, 800);
        return;
      }
  
      await addDatacheckProduct(selectedVariant);
      setTimeout(refreshDatacheckVisibility, 800);
    });
  }
  
  /* -----------------------------------------------------
     Add Datacheck to Cart
  ----------------------------------------------------- */
  const mainVariantEl = document.querySelector('.product-variant-id');
  const mainVariantId = mainVariantEl?.value;
  async function addDatacheckProduct(variantId) {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const exists = cart.items.some(i => String(i.id) === String(variantId));
      if (exists) return;
  
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: { _datacheck: true }
        })
      });
  
      localStorage.setItem('ck_datacheck_in_cart', 'true');
      localStorage.setItem('ck_datacheck_variant_id', variantId);
      localStorage.setItem('ck_datacheck_main_variant', mainVariantId);
    } catch (err) {
      console.error('[Datacheck] ERROR adding product:', err);
    }
  }
  
  /* -----------------------------------------------------
     Remove Datacheck from Cart
  ----------------------------------------------------- */
  async function removeDatacheckProduct() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const item = cart.items.find(i => i.properties && i.properties._datacheck);
      if (!item) return;
  
      const updates = {};
      updates[item.variant_id] = 0;
  
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
  
      localStorage.removeItem('ck_datacheck_in_cart');
    } catch (err) {
      console.error('[Datacheck] ERROR removing product:', err);
    }
  }
  
  /* -----------------------------------------------------
   Track REMOVE FROM CART buttons
  ----------------------------------------------------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-variant-id]');
    if (!btn) return;

    const removedVariant = btn.dataset.variantId;
    const savedDatacheck = localStorage.getItem('ck_datacheck_variant_id');
    const savedMain = localStorage.getItem('ck_datacheck_main_variant');

    /* -----------------------------------------------------
      CASE 1: User removed the Datacheck product
    ----------------------------------------------------- */
    if (savedDatacheck && removedVariant === savedDatacheck) {
      console.log('[Datacheck] Datacheck removed → cleaning…');

      localStorage.removeItem('ck_datacheck_in_cart');
      localStorage.removeItem('ck_datacheck_variant_id');
      localStorage.removeItem('ck_datacheck_main_variant');

      const injected = document.querySelector('.ck-datacheck--injected');
      const original = document.querySelector('[data-datacheck-wrapper]');

      [injected, original].forEach((wrapper) => {
        if (!wrapper) return;

        const freeOption = wrapper.querySelector('[data-datacheck-none]');
        const paidOption = wrapper.querySelector('[data-datacheck-product]');
        const hidden = wrapper.querySelector('[data-datacheck-hidden-input]');

        if (freeOption) freeOption.checked = true;
        if (paidOption) paidOption.checked = false;
        if (hidden) hidden.remove();
      });

      setTimeout(refreshDatacheckVisibility, 800);
      return;
    }

    /* -----------------------------------------------------
      CASE 2: User removed the MAIN product → remove datacheck too
    ----------------------------------------------------- */
    if (savedMain && removedVariant === savedMain) {
      console.log('[Datacheck] Main product removed → removing Datacheck');

      // remove datacheck line item from cart
      await removeDatacheckProduct();

      localStorage.removeItem('ck_datacheck_in_cart');
      localStorage.removeItem('ck_datacheck_variant_id');
      localStorage.removeItem('ck_datacheck_main_variant');

      const injected = document.querySelector('.ck-datacheck--injected');
      const original = document.querySelector('[data-datacheck-wrapper]');

      [injected, original].forEach((wrapper) => {
        if (!wrapper) return;

        const freeOption = wrapper.querySelector('[data-datacheck-none]');
        const paidOption = wrapper.querySelector('[data-datacheck-product]');
        const hidden = wrapper.querySelector('[data-datacheck-hidden-input]');

        if (freeOption) freeOption.checked = true;
        if (paidOption) paidOption.checked = false;
        if (hidden) hidden.remove();
      });

      setTimeout(() => {
        refreshDatacheckVisibility();
        ckRefreshCartDrawer();
      }, 500);
    }
  });

  
  /* -----------------------------------------------------
     TeeInBlue mobile event support
  ----------------------------------------------------- */
  document.addEventListener('teeinblue-event-after-add-to-cart', () => {
    setTimeout(refreshDatacheckVisibility, 600);
  });
  

  async function ckRefreshCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
  
    try {
      const res = await fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble");
      const sections = await res.json();
  
      drawer.renderContents({ sections });
      ckResetCountdown?.();
    } catch (e) {
      console.warn('[CK Datacheck] Failed to refresh drawer:', e);
    }
  }
  